import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useGame } from '../context/GameContext';
import { ArrowLeft, Play, Trophy, Calendar } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function todayStr() {
  const d = new Date();
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Simple deterministic seed derived from date
function seedForDate(date) {
  let h = 5381;
  for (let i = 0; i < date.length; i++) h = ((h << 5) + h + date.charCodeAt(i)) & 0xffffffff;
  const abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let s = 'D';
  let n = Math.abs(h);
  for (let i = 0; i < 5; i++) { s += abc[n % abc.length]; n = Math.floor(n / abc.length); }
  return s;
}

export default function DailyChallenge() {
  const { beginClassSelect, goToMenu } = useGame();
  const [top, setTop] = useState([]);
  const [loading, setLoading] = useState(true);
  const date = todayStr();
  const seed = seedForDate(date);

  useEffect(() => {
    axios.get(`${API}/leaderboard/daily/${date}?limit=15`)
      .then(r => setTop(r.data || []))
      .catch(() => setTop([]))
      .finally(() => setLoading(false));
  }, [date]);

  return (
    <div className="min-h-screen w-full px-6 py-6 max-w-5xl mx-auto">
      <div className="flex items-center justify-between">
        <button className="brutal-btn text-sm" onClick={goToMenu} data-testid="daily-back-button">
          <ArrowLeft size={16} /> BACK
        </button>
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.4em] text-[color:var(--text-dim)]">
          <Calendar size={14}/> {date}
        </div>
      </div>

      <h1 className="mt-4 font-display text-5xl sm:text-7xl font-black uppercase text-[color:var(--pink)] text-center">DAILY SLOP</h1>
      <div className="mt-2 text-center text-sm uppercase tracking-widest text-[color:var(--text-dim)]">
        everyone plays the same seed today. one shot. resets 00:00 UTC.
      </div>

      <div className="mt-6 brutal-border-pink p-6 bg-[#0a0a0a] flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-[color:var(--text-dim)]">TODAY'S SEED</div>
          <div className="font-display text-5xl font-black text-[color:var(--pink)] tracking-widest" data-testid="daily-seed">{seed}</div>
        </div>
        <button className="brutal-btn-pink brutal-btn text-lg" onClick={() => beginClassSelect(seed, date)} data-testid="start-daily-button">
          <Play size={18} /> RUN IT
        </button>
      </div>

      <div className="mt-10">
        <div className="flex items-center gap-2 text-[color:var(--neon)] mb-3">
          <Trophy size={18}/> <span className="font-display font-black uppercase text-lg">TODAY'S TOP</span>
        </div>
        {loading && <div className="text-[color:var(--text-dim)] text-sm">Loading...</div>}
        {!loading && top.length === 0 && (
          <div className="text-center py-10 brutal-border-dim text-[color:var(--text-dim)] uppercase text-sm">BE THE FIRST TO RUN IT TODAY</div>
        )}
        <div className="flex flex-col gap-2" data-testid="daily-leaderboard">
          {top.map((e, i) => (
            <div key={e.id} className={`flex items-center justify-between px-4 py-2 ${i === 0 ? 'brutal-border-pink' : 'brutal-border-dim'} bg-[#0a0a0a]`}
              data-testid={`daily-entry-${i}`}>
              <div className="flex items-center gap-4">
                <div className="font-display font-black text-xl w-8 text-[color:var(--neon)]">#{i+1}</div>
                <div className="font-display font-black uppercase">{e.player_name}</div>
              </div>
              <div className="flex items-center gap-6 text-xs uppercase font-mono">
                <span className="text-[color:var(--text-dim)]">FL <span className="text-white">{e.floor_reached}</span></span>
                <span className="font-display text-xl font-black text-[color:var(--neon)] w-24 text-right">{e.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
